// CEFAT Programs Data

export const diplomatePrograms = {
  bachelor: [
    {
      id: 'bba',
      name: 'Bachelor Business Administration (BBA)',
      slug: 'bachelor-business-administration',
      duration: '3 ans',
      level: 'Bac',
      description: 'Formation complète en gestion et administration des affaires, préparant les étudiants aux postes de management.',
      modules: [
        'Management général',
        'Marketing stratégique',
        'Finance d\'entreprise',
        'Ressources humaines',
        'Droit des affaires',
        'Anglais des affaires',
        'Gestion de projet',
        'Entrepreneuriat'
      ],
      career: [
        'Chef de projet',
        'Responsable commercial',
        'Consultant en management',
        'Entrepreneur',
        'Chargé de développement'
      ]
    },
    {
      id: 'bsc',
      name: 'Bachelor Computer Science (BSC)',
      slug: 'bachelor-computer-science',
      duration: '3 ans',
      level: 'Bac',
      description: 'Formation approfondie en informatique et technologies de l\'information pour les métiers du numérique.',
      modules: [
        'Programmation avancée',
        'Base de données',
        'Réseaux informatiques',
        'Sécurité informatique',
        'Développement web',
        'Intelligence artificielle',
        'Gestion de projets IT',
        'Cloud computing'
      ],
      career: [
        'Développeur full-stack',
        'Administrateur systèmes',
        'Chef de projet IT',
        'Data analyst',
        'Consultant IT'
      ]
    }
  ],
  master: [
    {
      id: 'mba-finance',
      name: 'MBA Finance',
      slug: 'mba-finance',
      duration: '2 ans',
      level: 'Bac+3',
      description: 'Spécialisation en finance d\'entreprise, marchés financiers et gestion des risques.',
      modules: [
        'Finance d\'entreprise avancée',
        'Marchés financiers',
        'Gestion des risques',
        'Analyse financière',
        'Audit et contrôle de gestion',
        'Finance internationale'
      ],
      career: [
        'Directeur financier',
        'Analyste financier',
        'Contrôleur de gestion',
        'Risk manager',
        'Conseiller en investissement'
      ]
    },
    {
      id: 'mba-gestion',
      name: 'MBA Gestion d\'Entreprise',
      slug: 'mba-gestion-entreprise',
      duration: '2 ans',
      level: 'Bac+3',
      description: 'Formation aux techniques avancées de management et de pilotage d\'entreprise.',
      modules: [
        'Stratégie d\'entreprise',
        'Leadership et management',
        'Gestion des opérations',
        'Marketing stratégique',
        'Négociation commerciale',
        'Management interculturel'
      ],
      career: [
        'Directeur général',
        'Directeur des opérations',
        'Consultant senior',
        'Directeur de business unit',
        'Entrepreneur'
      ]
    },
    {
      id: 'mba-durabilite',
      name: 'MBA Gestion de la Durabilité',
      slug: 'mba-gestion-durabilite',
      duration: '2 ans',
      level: 'Bac+3',
      description: 'Spécialisation en développement durable et responsabilité sociale des entreprises.',
      modules: [
        'Développement durable',
        'RSE et éthique',
        'Économie circulaire',
        'Management environnemental',
        'Finance verte',
        'Reporting extra-financier'
      ],
      career: [
        'Directeur RSE',
        'Consultant en développement durable',
        'Chef de projet environnement',
        'Responsable ESG',
        'Auditeur environnemental'
      ]
    },
    {
      id: 'mba-intelligence',
      name: 'MBA Intelligence Économique',
      slug: 'mba-intelligence-economique',
      duration: '2 ans',
      level: 'Bac+3',
      description: 'Formation à la veille stratégique, l\'analyse concurrentielle et la protection de l\'information.',
      modules: [
        'Veille stratégique',
        'Analyse concurrentielle',
        'Protection de l\'information',
        'Lobbying et influence',
        'Gestion de crise',
        'Cybersécurité'
      ],
      career: [
        'Directeur de l\'intelligence économique',
        'Analyste stratégique',
        'Consultant en veille',
        'Risk manager',
        'Responsable sécurité de l\'information'
      ]
    },
    {
      id: 'mba-digital',
      name: 'MBA Transformation Numérique & Analytique',
      slug: 'mba-transformation-numerique',
      duration: '2 ans',
      level: 'Bac+3',
      description: 'Pilotage de la transformation digitale et exploitation des données pour la décision.',
      modules: [
        'Transformation digitale',
        'Big Data et analytics',
        'Intelligence artificielle',
        'E-commerce et marketing digital',
        'Gestion de projet agile',
        'Innovation et design thinking'
      ],
      career: [
        'Chief Digital Officer',
        'Data scientist',
        'Consultant en transformation digitale',
        'Product manager',
        'Responsable innovation'
      ]
    },
    {
      id: 'mcs',
      name: 'Master Computer Science (MCS)',
      slug: 'master-computer-science',
      duration: '2 ans',
      level: 'Bac+3',
      description: 'Formation avancée en informatique avec spécialisation en IA, cybersécurité ou data.',
      modules: [
        'Machine learning avancé',
        'Deep learning',
        'Cybersécurité avancée',
        'Architecture cloud',
        'DevOps et CI/CD',
        'Recherche en informatique'
      ],
      career: [
        'Ingénieur IA',
        'Architecte cloud',
        'Expert cybersécurité',
        'Lead developer',
        'Chercheur en informatique'
      ]
    }
  ],
  admission: {
    steps: [
      {
        step: 1,
        title: 'Dépôt du dossier',
        description: 'Soumettez votre dossier de candidature en ligne avec tous les documents requis.'
      },
      {
        step: 2,
        title: 'Étude du dossier',
        description: 'Notre comité d\'admission évalue votre parcours académique et professionnel.'
      },
      {
        step: 3,
        title: 'Test écrit',
        description: 'Passez notre test d\'aptitude qui évalue vos compétences générales et spécifiques.'
      },
      {
        step: 4,
        title: 'Entretien de motivation',
        description: 'Présentez votre projet professionnel devant un jury de professeurs et professionnels.'
      },
      {
        step: 5,
        title: 'Décision finale',
        description: 'Recevez la décision du comité d\'admission sous 2 semaines.'
      }
    ],
    documents: [
      'Copie des diplômes',
      'Relevés de notes',
      'CV détaillé',
      'Lettre de motivation',
      'Pièce d\'identité',
      'Photo d\'identité',
      'Attestations de travail (si applicable)'
    ]
  }
};

export const qualifiantePrograms = [
  {
    id: 'delegue-medical',
    name: 'Délégué médical bilingue',
    slug: 'delegue-medical-bilingue',
    level: 'Bac',
    duration: '12 mois',
    price: 850000,
    description: 'Formation complète pour devenir délégué médical capable de travailler en français et en anglais.',
    modules: [
      'Anatomie et physiologie',
      'Pharmacologie',
      'Techniques de vente',
      'Communication médicale',
      'Anglais médical',
      'Éthique et réglementation'
    ],
    career: [
      'Délégué médical',
      'Visiteur médical',
      'Responsable de secteur pharmaceutique',
      'Attaché scientifique'
    ]
  },
  {
    id: 'auxiliaire-sante',
    name: 'Auxiliaire de santé',
    slug: 'auxiliaire-de-sante',
    level: '3ème',
    duration: '12 mois',
    price: 550000,
    description: 'Formation aux soins de base et à l\'accompagnement des patients dans les structures de santé.',
    modules: [
      'Soins de base',
      'Hygiène hospitalière',
      'Accompagnement des patients',
      'Premiers secours',
      'Communication avec les patients',
      'Éthique professionnelle'
    ],
    career: [
      'Auxiliaire de santé',
      'Aide-soignant',
      'Agent hospitalier',
      'Assistant médical'
    ]
  },
  {
    id: 'auxiliaire-vie',
    name: 'Auxiliaire de vie',
    slug: 'auxiliaire-de-vie',
    level: '3ème',
    duration: '12 mois',
    price: 550000,
    description: 'Formation à l\'accompagnement des personnes dépendantes dans les actes de la vie quotidienne.',
    modules: [
      'Accompagnement quotidien',
      'Nutrition et alimentation',
      'Mobilité et transferts',
      'Communication et relation d\'aide',
      'Sécurité et prévention',
      'Administratif et organisation'
    ],
    career: [
      'Auxiliaire de vie',
      'Aide à domicile',
      'Assistant de vie aux familles',
      'Accompagnant éducatif et social'
    ]
  },
  {
    id: 'auxiliaire-vie-courte',
    name: 'Auxiliaire de vie (option courte)',
    slug: 'auxiliaire-vie-option-courte',
    level: '3ème',
    duration: '9 mois',
    price: 325000,
    description: 'Formation accélérée aux fondamentaux de l\'accompagnement des personnes dépendantes.',
    modules: [
      'Soins de base',
      'Accompagnement quotidien',
      'Sécurité et prévention',
      'Communication'
    ],
    career: [
      'Auxiliaire de vie',
      'Aide à domicile'
    ]
  },
  {
    id: 'caissier',
    name: 'Caissier(e) spécialisé(e)',
    slug: 'caissier-specialise',
    level: '6ème',
    duration: '9 mois',
    price: 325000,
    description: 'Formation aux techniques de caisse et à la relation client en point de vente.',
    modules: [
      'Techniques de caisse',
      'Gestion des stocks',
      'Relation client',
      'Comptabilité de base',
      'Informatique commerciale'
    ],
    career: [
      'Caissier',
      'Employé de commerce',
      'Hôte de caisse',
      'Assistant de vente'
    ]
  },
  {
    id: 'caissier-bilingue',
    name: 'Caissier(e) spécialisé(e) bilingue',
    slug: 'caissier-specialise-bilingue',
    level: '6ème',
    duration: '9 mois',
    price: 600000,
    description: 'Formation aux techniques de caisse avec maîtrise de l\'anglais commercial.',
    modules: [
      'Techniques de caisse',
      'Relation client',
      'Anglais commercial',
      'Communication bilingue',
      'Comptabilité',
      'Informatique commerciale'
    ],
    career: [
      'Caissier bilingue',
      'Hôte de caisse international',
      'Employé de commerce international'
    ]
  },
  {
    id: 'assistante-bilingue',
    name: 'Assistante bilingue',
    slug: 'assistante-bilingue',
    level: 'Bac',
    duration: '9 mois',
    price: 850000,
    description: 'Formation aux métiers de l\'assistanat avec maîtrise de l\'anglais professionnel.',
    modules: [
      'Secrétariat et bureautique',
      'Organisation administrative',
      'Anglais des affaires',
      'Communication professionnelle',
      'Gestion du temps',
      'Outils numériques'
    ],
    career: [
      'Assistante de direction',
      'Secrétaire bilingue',
      'Office manager',
      'Assistante administrative'
    ]
  },
  {
    id: 'receptionniste',
    name: 'Réceptionniste d\'hôtel bilingue',
    slug: 'receptionniste-hotel-bilingue',
    level: '3ème',
    duration: '9 mois',
    price: 850000,
    description: 'Formation aux métiers de l\'accueil hôtelier avec maîtrise de l\'anglais.',
    modules: [
      'Techniques d\'accueil',
      'Gestion des réservations',
      'Anglais hôtelier',
      'Communication client',
      'Logiciels hôteliers',
      'Tourisme et patrimoine'
    ],
    career: [
      'Réceptionniste d\'hôtel',
      'Agent de réservation',
      'Concierge',
      'Responsable accueil'
    ]
  },
  {
    id: 'community-manager',
    name: 'Community Manager',
    slug: 'community-manager',
    level: 'Terminale',
    duration: '9 mois',
    price: 550000,
    description: 'Formation aux métiers de la communication digitale et de la gestion des réseaux sociaux.',
    modules: [
      'Stratégie réseaux sociaux',
      'Création de contenu',
      'Community management',
      'Publicité digitale',
      'Analyse de données',
      'Outils graphiques'
    ],
    career: [
      'Community manager',
      'Social media manager',
      'Content creator',
      'Digital marketer'
    ]
  }
];

export const certifiantePrograms = [
  {
    id: 'gestion-projet-humanitaire',
    name: 'Gestion de projet humanitaire',
    slug: 'gestion-projet-humanitaire',
    duration: '3 mois',
    price: 500000,
    description: 'Certificat en gestion de projets dans le secteur humanitaire et ONG.',
    partners: ['BIT', 'FDFP']
  },
  {
    id: 'plaidoyer',
    name: 'Plaidoyer et influence',
    slug: 'plaidoyer-influence',
    duration: '2 mois',
    price: 350000,
    description: 'Techniques de plaidoyer et d\'influence pour les professionnels du développement.'
  },
  {
    id: 'logistique',
    name: 'Logistique humanitaire',
    slug: 'logistique-humanitaire',
    duration: '3 mois',
    price: 450000,
    description: 'Gestion de la chaîne logistique dans les contextes humanitaires.'
  },
  {
    id: 'sante-publique',
    name: 'Santé publique',
    slug: 'sante-publique',
    duration: '4 mois',
    price: 600000,
    description: 'Fondamentaux de la santé publique et gestion des programmes de santé.'
  },
  {
    id: 'cybersecurite',
    name: 'Cybersécurité',
    slug: 'cybersecurite',
    duration: '3 mois',
    price: 750000,
    description: 'Formation aux techniques de sécurité informatique et protection des données.'
  },
  {
    id: 'intelligence-artificielle',
    name: 'Intelligence Artificielle',
    slug: 'intelligence-artificielle',
    duration: '4 mois',
    price: 800000,
    description: 'Introduction à l\'IA, machine learning et applications pratiques.'
  },
  {
    id: 'marketing-digital',
    name: 'Marketing Digital',
    slug: 'marketing-digital',
    duration: '3 mois',
    price: 450000,
    description: 'Stratégies de marketing digital, SEO, SEM et réseaux sociaux.'
  },
  {
    id: 'leadership',
    name: 'Leadership et Management',
    slug: 'leadership-management',
    duration: '2 mois',
    price: 400000,
    description: 'Développement des compétences de leadership et management d\'équipe.'
  },
  {
    id: 'gestion-generale',
    name: 'Gestion générale',
    slug: 'gestion-generale',
    duration: '3 mois',
    price: 500000,
    description: 'Fondamentaux de la gestion d\'entreprise pour les managers.'
  }
];

export const linguistiquePrograms = [
  {
    id: 'sejour-accra',
    name: 'Séjour linguistique à Accra',
    slug: 'sejour-linguistique-accra',
    duration: '3 mois',
    price: 1500000,
    description: 'Immersion totale en anglais à Accra avec hébergement et cours intensifs.',
    includes: ['Hébergement', 'Cours intensifs', 'Activités culturelles', 'Certificat']
  },
  {
    id: 'anglais-affaires',
    name: 'Anglais des affaires',
    slug: 'anglais-des-affaires',
    duration: '6 mois',
    price: 600000,
    description: 'Formation à l\'anglais professionnel pour les cadres et entrepreneurs.',
    levels: ['Débutant', 'Intermédiaire', 'Avancé']
  },
  {
    id: 'stage-accra',
    name: 'Stage professionnel à Accra',
    slug: 'stage-professionnel-accra',
    duration: '3 mois',
    price: 2000000,
    description: 'Stage en entreprise à Accra combiné à des cours d\'anglais.',
    includes: ['Hébergement', 'Stage en entreprise', 'Cours d\'anglais', 'Accompagnement']
  },
  {
    id: 'anglais-general',
    name: 'Anglais général',
    slug: 'anglais-general',
    duration: '4 mois',
    price: 400000,
    description: 'Cours d\'anglais général pour tous les niveaux.',
    levels: ['Débutant', 'Élémentaire', 'Intermédiaire', 'Avancé']
  }
];

export const campuses = [
  {
    name: 'Campus Abidjan (Siège)',
    address: 'Cocody Angré 8e Tranche, Carrefour Prière, Rue L259',
    city: 'Abidjan',
    country: 'Côte d\'Ivoire',
    phone: '+225 07 12 65 17 19',
    phone2: '+225 01 00 95 95 18',
    email: 'cefat.bs@gmail.com',
    bp: 'BP 1238, Rue William Ipot2 (L84)',
    coordinates: { lat: 5.3928, lng: -3.9759 }
  }
];
